import { make } from 'vuex-pathify';
import { PastDueDaysRangeService } from '../services/past-due-days-range.service.js';
import Logger from '@/lib/logger.js';

const service = new PastDueDaysRangeService();

const state = {
  pastDueDaysRanges: []
};

const mutations = make.mutations(state);

const actions = {
  async fetchPastDueDaysRanges({ commit }, params) {
    try {
      const { data } = await service.fetchPastDueDaysRanges(params);
      commit('SET_PAST_DUE_DAYS_RANGES', data.data || []);
      return data;
    } catch (error) {
      Logger.error('Getting Past Due Days Range');
      throw error;
    }
  },

  async updatePastDueDaysRange(_, { updates }) {
    try {
      const { data } = await service.updatePastDueDaysRange(updates);
      return data;
    } catch (error) {
      Logger.error('Updating Past Due Days Range');
      throw error;
    }
  }
};

export default {
  state,
  mutations,
  actions
};
